'use strict';

const _=require('pulsar-utils/dist-es6/_');
const LiveGroupBasedDataService=require('../../../dist-es6/client/services/liveGroupBasedDataService');let

DashboardDataService=class DashboardDataService extends LiveGroupBasedDataService{
static get $inject(){
return[
'$timeout',
'dateService',
'statisticalDisplayDataService',
'groupTreeService'];

}

constructor($timeout,dateService,statisticalDisplayDataService,groupTreeService){
super($timeout,dateService,statisticalDisplayDataService,groupTreeService);
}

async _fetchLatestData(...args){
return await this._statisticalDisplayDataService.fetchDashboardData(...args);
}};


module.exports=DashboardDataService;
//# sourceMappingURL=dashboardDataService.js.map
